import axios from 'axios';
import FirebaseTokenValidator from '../../utils/authentication/FirebaseTokenValidator';
import { logout } from '../../utils';

/* 
  Factory method for create a multiple base url instances
  Also, added request and response interceptor to attach and validate the token
*/

const createApiInstance = (baseURL) => {
  const api = axios.create({ baseURL });
  api.interceptors.request.use(
    async (config) => {
      const  tokenValidator  = new FirebaseTokenValidator();
      const token = await tokenValidator.getToken();
      const validatorRes = await tokenValidator.validate(token);
      if(token && validatorRes.isValid) {
        const modifiedConfig = { ...config };
        modifiedConfig.headers = { ...config.headers, Authorization: `Bearer ${token}` };
        return modifiedConfig; 
      } else {
        await logout();
        window.location.href = '/login';
      }
    },
    (error) => Promise.reject(error)
  );
  /* 
    Handle the server side error 
    Handle the etag in response to tight bind the client and server
    server will excnage the etag to client on the basis of browser agent ip address and co-relation id
  */

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      return errorHandler(error);
    }
  );
  return api;
};

/*
  Global error handler method for instance 
*/

const errorHandler = async (error) => {
  const statusCode = error.response?.status;
  if (statusCode && statusCode === 401) {
    await logout();
    window.location.href = '/login';
  }
  return Promise.reject(error);
};

const ecoAxios = createApiInstance(process.env.REACT_APP_ECO_API_ENDPOINT);
const customerAxios = createApiInstance(process.env.REACT_APP_CUSTOMER_API_ENDPOINT);
const gamutServiceAxios = createApiInstance(process.env.REACT_APP_GAMUT_SERVICE_API_ENDPOINT);


export { ecoAxios, customerAxios, gamutServiceAxios };



